module.exports = __webpack_public_path__ + "img/diffusal_blade_2.663cd05c.png";